class ProductFaqs extends HTMLElement {
  constructor() {
    super();

    this.questions = this.querySelectorAll('[faq-question]')
    this.onClickTitle = this.onClickTitle.bind(this)
  }

  connectedCallback() {
    this.questions.forEach(item => {
      item.addEventListener('click', () => {
        this.onClickTitle(item)
      }, false)
    })
  }

  onClickTitle(item) {
    const answer = item.parentElement.querySelector('[faq-answer')
    if(answer.hasAttribute('hidden')) {
      answer.removeAttribute('hidden')
      answer.setAttribute('data-state', 'open')
      this.setAttribute('aria-expanded', 'true')
      item.parentElement.setAttribute('data-state', 'open')
    } else {
      answer.setAttribute('data-state', 'close')
      answer.setAttribute('hidden', '')
      this.setAttribute('aria-expanded', 'false')
      item.parentElement.setAttribute('data-state', 'close')
    }
  }
}

customElements.define('product-faqs', ProductFaqs);
